import { render, staticRenderFns } from "./DocumentLibraryDialog.vue?vue&type=template&id=0a5dbeed&"
import script from "./DocumentLibraryDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentLibraryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports